import React from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/pagination/datatable";
import { filterMgtTable } from "../../../core/json/filtermgttable";
import { assetmgtHostAsset } from "../../../core/json/assetmgthostasset";
import { asstmgtassetitems } from "../../../core/json/assetmgtassetitems";
import { assetItemData } from "../../../core/json/asstitemdata";
const UserDashboard = () => {
  const DCdataSource = filterMgtTable;
  const AHMDataSource = assetmgtHostAsset;
  const ASIDataSource = asstmgtassetitems;
  const ASRDataSource = assetItemData;

  const DCcolumns = [
    {
      title: "Filter ID",
      dataIndex: "filterId",
      key: "filterId",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "Micron Rating",
      dataIndex: "micronRating",
      key: "micronRating",
    },
    {
      title: "Last Cleaned",
      dataIndex: "lastCleaned",
      key: "lastCleaned",
    },
    {
      title: "Label",
      dataIndex: "label",
      key: "label",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: () => (
        <div className="">
          <div className="edit-delete-action d-flex align-items-center">
            <Link
              to="/assetmgt/barcodescanner"
              className="btn me-2 p-2"
              title="Scan Filter"
            >
              <i className="ri-qr-scan-line "></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];
  const AHMcolumns = [
    {
      title: "AHU ID",
      dataIndex: "ahu_unique_id",
      key: "ahu_unique_id",
      sorter: (a, b) => a.ahu_unique_id.localeCompare(b.ahu_unique_id),
      render: (text) => (
        <Link
          // data-bs-toggle="offcanvas"
          // data-bs-target="#offcanvasRightViewHostAsset"
          // aria-controls="offcanvasRightViewHostAsset"
          // onClick={() => setSelectedData(record)}
          title={text}
        >
          {text.length > 10 ? `${text.substring(0, 10)}...` : text}
        </Link>
      ),
    },
    {
      title: "Description",
      dataIndex: "ahu_description",
      key: "ahu_description",
      render: (text) => (
        <span title={text}>
          {text.length > 10 ? `${text.substring(0, 10)}...` : text}
        </span>
      ),
    },
    {
      title: "Area/Zone ",
      dataIndex: "area_zone_served",
      key: "area_zone_served",

      render: (text) => (
        <span title={text}>
          {text.length > 10 ? `${text.substring(0, 10)}...` : text}
        </span>
      ),
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",

      render: (text) => (
        <span title={text}>
          {text.length > 10 ? `${text.substring(0, 10)}...` : text}
        </span>
      ),
    },
    {
      title: "Manufacturer",
      dataIndex: "manufacturer",
      key: "manufacturer",
    },
    {
      title: "Model No",
      dataIndex: "model_number",
      key: "model_number",
    },
    {
      title: "Capacity ",
      dataIndex: "capacity_cfm",
      key: "capacity_cfm",
      // sorter: (a, b) => a.capacity_cfm - b.capacity_cfm,
    },
    {
      title: "Filters",
      dataIndex: "number_of_filters",
      key: "number_of_filters",
      // sorter: (a, b) => a.number_of_filters - b.number_of_filters,
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      render: (text) => (
        <span title={text}>
          {text.length > 10 ? `${text.substring(0, 10)}...` : text}
        </span>
      ),
    },
  ];
  const ASIColumns = [
    {
      title: "Filter ID",
      dataIndex: "filter_unique_id",
      key: "filter_unique_id",
      render: (text, record) => {
        let dotColor = "bg-secondary";
        const status = record.current_status;

        if (status === "Active") dotColor = "bg-success";
        else if (status === "Cleaning") dotColor = "bg-warning";
        else if (status === "Storage") dotColor = "bg-info";

        return (
          <Link
            to="#"
            // data-bs-toggle="offcanvas"
            // data-bs-target="#offcanvasRightViewFilterAsset"
            // onClick={() => setViewData(record)}
            title={text}
            className="d-flex align-items-center gap-2"
          >
            <span
              className={`rounded-circle ${dotColor}`}
              title={status} // <-- shows tooltip with status on hover
              style={{
                width: "10px",
                height: "10px",
                display: "inline-block",
              }}
            ></span>
            {text.length > 10 ? `${text.substring(0, 10)}...` : text}
          </Link>
        );
      },
    },
    {
      title: "Category",
      dataIndex: "filter_type",
      key: "filter_type",
    },
    {
      title: "Installed on",
      dataIndex: "installation_date",
      key: "installation_date",
    },
    {
      title: "Location ",
      dataIndex: "location_type",
      key: "location_type",
    },
    {
      title: "Last Cleaning ",
      dataIndex: "last_cleaning_date",
      key: "last_cleaning_date",
    },
    {
      title: "AHU ID",
      dataIndex: "ahu_unique_id",
      key: "ahu_unique_id",
    },
    {
      title: "Availability",
      dataIndex: "availability_status",
      key: "availability_status",
      render: (availability) => {
        let textColor = "text-secondary";
        if (availability === "In Use") textColor = "text-primary";
        else if (availability === "Spare") textColor = "text-success";

        return (
          <span className={`fw-semibold ${textColor}`}>{availability}</span>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: () => (
        <div className="">
          <div className="edit-delete-action d-flex align-items-center">
            <Link
              to="/assetmgt/barcodescanner"
              className="btn me-2 p-2"
              title="Scan Filter"
            >
              <i className="ri-qr-scan-line "></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];
  const ASRColumns = [
    {
      title: "Fiter Code",
      dataIndex: "assetCode",
    },
    {
      title: "Filter Name",
      dataIndex: "assetName",
    },

    {
      title: "Assigned To",
      dataIndex: "assignedTo",
    },
    {
      title: "Location",
      dataIndex: "location",
    },
    {
      title: "Purchase Date",
      dataIndex: "purchaseDate",
    },
    {
      title: "Warranty (Months)",
      dataIndex: "warranty",
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   render: (status) => (
    //      <span className={`badge ${status === "Active" ? "bg-success" : "bg-danger"}`}>
    //   {status}
    // </span>
    //   ),
    // },
  ];

  const assetCards = [
    {
      label: "AHU ",
      value: 24, // Replace with your actual data
      bgClass: "bg-primary",
      textClass: "text-primary",
      iconClass: "bi bi-fan", // Bootstrap icon for AHU
    },
    {
      label: "Filters ",
      value: 132, // Replace with your actual data
      bgClass: "bg-secondary",
      textClass: "text-secondary",
      iconClass: "bi bi-funnel", // Bootstrap icon for filter
    },
    {
      label: "In Use",
      value: 47, // Replace with your actual data
      bgClass: "bg-teal",
      textClass: "text-teal",
      iconClass: "bi bi-people", // Bootstrap icon for users
    },
    {
      label: "Out For Service",
      value: 16, // Replace with your actual data (e.g., broken or due filters)
      bgClass: "bg-warning",
      textClass: "text-warning",
      iconClass: "bi bi-exclamation-circle", // Alert icon
    },
  ];

  return (
    <>
      <div className="page-wrapper pt-5">
        <div className="content">
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-2">
            <div className="mb-3">
              <h1 className="mb-1">Filter Tracking</h1>
              <p className="fw-medium">
                You have <span className="text-primary fw-bold">20+</span>
                New Filters, Today
              </p>
            </div>
            <div>
              <Link title="scan barcode" to="/assetmgt/barcodescanner">
                <i className="ri-qr-scan-line fs-4"></i>
              </Link>
            </div>
          </div>

          <div className="row">
            {assetCards.map((card, index) => (
              <div key={index} className="col-xl-3 col-sm-6 col-12 d-flex">
                <Link className={`card  sale-widget flex-fill`}>
                  <div className="card-body d-flex align-items-center">
                    <span className={`sale-icon bg-white ${card.textClass}`}>
                      <i className={`${card.iconClass} fs-2`} />
                    </span>
                    <div className="ms-2">
                      <p className={`${card.textClass} fw-bold mb-1`}>
                        {card.label}
                      </p>
                      <div className="d-inline-flex align-items-center flex-wrap gap-2">
                        <h4 className={`${card.textClass}`}>{card.value}</h4>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          <div className="card">
            <div className="card-header mt-4">
              <h5 className="card-title"></h5>
            </div>
            <div className="card-body">
              <ul className="nav nav-tabs nav-tabs-bottom mb-3">
                <li className="nav-item">
                  <Link
                    className="nav-link active"
                    to="#bottom-tab1"
                    data-bs-toggle="tab"
                  >
                    Due For Cleaning
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#bottom-tab2"
                    data-bs-toggle="tab"
                  >
                    AHU Machines
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#bottom-tab3"
                    data-bs-toggle="tab"
                  >
                    Filters
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="#bottom-tab4"
                    data-bs-toggle="tab"
                  >
                    Reports
                  </Link>
                </li>
              </ul>
              <div className="table-responsive">
                <div className="tab-content">
                  <div className="tab-pane show active" id="bottom-tab1">
                    <Table columns={DCcolumns} dataSource={DCdataSource} />
                  </div>
                  <div className="tab-pane" id="bottom-tab2">
                    <Table columns={AHMcolumns} dataSource={AHMDataSource} />
                  </div>
                  <div className="tab-pane" id="bottom-tab3">
                    <Table columns={ASIColumns} dataSource={ASIDataSource} />
                  </div>
                  <div className="tab-pane" id="bottom-tab4">
                    <Table columns={ASRColumns} dataSource={ASRDataSource} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserDashboard;
